var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-content',{staticClass:"h-panel"},[_c('Tabs',{attrs:{"datas":_vm.tabDatas},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_c('div',{staticClass:"h-panel-body padding"},[_c(_vm.selected,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }